// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__-LOwi","text":"SelectPayment_text__1rkYW","title":"SelectPayment_title__384Br","btn":"SelectPayment_btn__P7SoF"};